export default {
    nav: {
        Down: 'ดาวน์โหลดเลย',
        ReserveGift: 'นัดรับรางวัล',
        CharacterIntroduction: 'แนะนำตัวละคร',
        Gameplay: 'แนะนำเกม',
        AttentionFB: 'โปรฯเติมเงิน',
    },
}
